import Service from "../Service";

const resource = "FarmLot/";

export default {
    save(flt, requestID) {
        return Service.post(resource + "save", flt, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        // console.log('parametro', parameters)
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    searchlottransfer(parameters, requestID) {
        return Service.post(resource + "searchlottransfer", parameters, {
            params: { requestID: requestID },
        });
    },

    getLotGeometryGeoJSONById(fltId, requestID) {
        return Service.get(resource + `geojsonById/${fltId}`, {
            params: { requestID: requestID },
        });
    },
    getLotsGeometryGeoJSONByFag(fagId, requestID) {
        return Service.get(resource + `geojsonByFag/${fagId}`, {
            params: { requestID: requestID },
        });
    },
    getSublotsGeometryGeoJSONByParent(parentFltId, requestID) {
        return Service.get(resource + `geojsonByParent/${parentFltId}`, {
            params: { requestID: requestID },
        });
    },
    getListMin(requestID, fagId){
        const params = { requestID };
        if (fagId != null) params.fagId = fagId;
        return Service.get(resource + 'list-min', { params });
    },
    getListAll(requestID, fagId, includeSublots=true, search='',zone){
        const params = { requestID, includeSublots };
        if (fagId != null) params.fagId = fagId;
        if (search) params.search = search;
        if (zone) params.ZonID = zone;
        return Service.get(resource + 'list-all', { params });
    },
    refreshCacheLotPoint(lot, requestID) {
        const toDecimal = (v)=>{
            if (v == null) return undefined;
            if (typeof v === 'number') return v;
            const s = String(v).trim();
            if (!s.includes('°')) return parseFloat(s);
            const re = /([\d.]+)°\s*([\d.]+)?'?\s*([\d.]+)?"?\s*([NSEWnsew-])?/;
            const m1 = s.match(re);
            if (!m1) return parseFloat(s);
            const deg = parseFloat(m1[1]||0), min = parseFloat(m1[2]||0), sec = parseFloat(m1[3]||0);
            let sign = 1;
            if (/S|s|W|w|-/.test(s)) sign = -1;
            return sign*(deg + (min/60) + (sec/3600));
        };
        const payload = {
            fltId: lot.FltID || lot.fltId,
            lat: lot.lat ?? toDecimal(lot.FltLatituded),
            lon: lot.lon ?? toDecimal(lot.FltLength),
        };
        return Service.post(resource + "point", payload, {
            params: { requestID: requestID },
        });
    },
    refreshCacheLotGeometry(fltId, geometry, requestID) {
        return Service.post(resource + "geometryWkt", { fltId: fltId, geometry: geometry }, {
            params: { requestID: requestID },
        });
    },
    
    updateMassive(payload, requestID) {
        return Service.post(resource + "update-massive", payload, {
            params: { requestID: requestID },
        });
    },
    //pdf
};
